import { render } from "./SidebarGroupContent.vue?vue&type=template&id=2ee1e41d&ts=true"
import script from "./SidebarGroupContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarGroupContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarGroupContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ee1e41d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ee1e41d', __exports__)) {
    api.reload('2ee1e41d', __exports__)
  }
  
  module.hot.accept("./SidebarGroupContent.vue?vue&type=template&id=2ee1e41d&ts=true", () => {
    api.rerender('2ee1e41d', render)
  })

}


export default __exports__